<template>
    <section class="flow__panel">
        <hh-error-display v-if="error" :error="error" />
        <loading-animation v-else>
            {{ commonResources.loadingMessage }}
        </loading-animation>
    </section>
</template>

<script>

import LoadingAnimation from '@/components/app-core/loading-animation'
import AuthManager from '@/auth/auth-manager'
import ResourcesHelper from '@/components/resources-helper'

export default {
    mixins: [
        ResourcesHelper,
    ],
    created() {
        if (!this.userKey)
            this.$router.push({ name: 'Welcome' })
    },
    async mounted() {
        await this.login()
    },
    computed: {
        /**
         * @returns {?string}
         */
        userKey() {
            return this.$route.params.key || null
        },
    },
    components: {
        LoadingAnimation,
    },
    data() {
        return {
            /**
                * @type {?string}
                */
            error: null,
        }
    },
    methods: {
        async login() {
            this.error = null

            try {
                const defaultAddressId = await AuthManager.logInExternalAsync(this.userKey)

                if (defaultAddressId)
                    this.$router.push({ name: 'Dashboard' })
                else
                    this.$router.push({ name: 'Search' })

            } catch (err) {
                this.error = 'The provided owner was not found on the system'
            }
        },
    },
}

</script>
